import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import config from '../../../config/config';
import './MapComponent.css';

// Fix for default marker icon issue in react-leaflet
// delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

interface MapComponentProps {
  location?: [number, number];
  zoom?: number;
  markerTitle?: string;
}

const MapComponent: React.FC<MapComponentProps> = ({ 
  location = [35.7595, -5.8340], 
  zoom = 15,
}) => {
  return (
    <MapContainer 
      center={location} 
      zoom={zoom} 
      scrollWheelZoom={false}
      className="map-container"
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={location}>
        <Popup>
          <div className="popup-content">
            <h4 className="popup-title">Africa Supply Service SARL</h4>
            <p className="popup-address">{config.contact.address}</p>
            <div className="popup-contact">
              <p className="popup-phone">{config.contact.phone}</p>
              <p className="popup-email">{config.contact.email}</p>
            </div>
            <a 
              className="popup-button" 
              href={`https://www.google.com/maps/dir//${encodeURIComponent(config.contact.address)}`} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              Itinéraire
            </a>
          </div>
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapComponent;
